import React, { useRef, useState, useEffect } from "react";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import Header from "./header";
import MyFooter from "./my footer";
import FeatherIcon from "feather-icons-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useParams,useLocation } from "react-router-dom";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { all } from "axios";

const CourseDetail = () => {
  const videoRefs = useRef([]);
  const { courseId } = useParams();
  const [data, setData] = useState([]);
  const token = getToken();
  const std_id = decodeToken(token, "id");
  const location=useLocation();
  const [allowedTabs,setAllowedTabs]=useState([]);

   const { course_id, class_id, semester_id, student_id }=location.state ||{}
    const [percent, setPercent] = useState({});

   
const handleTimeUpdate = async(index, key,chapter_id) => {
  console.log('current chapter',chapter_id)
  const video = videoRefs.current[index];
  if (!video) return;

  const watched = (video.currentTime / video.duration) * 100;
  const time=watched.toFixed(1);

  setPercent((prev) => ({
    ...prev,
    [key]: watched.toFixed(1),
  }));

  // localStorage.setItem(`video-${key}`, video.currentTime);

 const  url=`${API_URL}/${ENDPOINTS.SYS}/reportCustom/register-video_percentage`;
 const body={course_id:courseId,student_id,percentage:time,
  date:'',
  chapter_id}

 const response=await postData(url,body);
 console.log('registered percentage ='.repeat.data)

};
  
const restoreProgress = async (index, key, chapter_id) => {
  const video = videoRefs.current[index];
  if (!video) return;

  const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/getVideoPercentage`;
  const body = { student_id, course_id: Number(courseId), chapter_id };
  const response = await postData(url, body);
  const savedTime = response.data[0]?.['percentage'] || 0.00; 

  if (savedTime && !isNaN(video.duration)) {
    // video.currentTime = Number(savedTime);
    video.currentTime = (savedTime / 100) * video.duration;


  }

  const watched = video.duration ? (video.currentTime / video.duration) * 100 : 0;

  setPercent((prev) => ({
    ...prev,
    [key]: watched.toFixed(1),
  }));
};

  
  useEffect(()=>{
     console.log(
    "course_id:", course_id,
    "class_id:", class_id,
    "semester_id:", semester_id,
    "student_id:", student_id
  );
  },class_id)
  useEffect(() => {
    const getCourse = async () => {
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/get-course-video-slides`;
        const body = { course_id: courseId, std_id };
        const response = await postData(url, body);
        console.log('data',response.data)
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getTabs= async()=>{
      const tabsUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/Web-Tab`;
          const tabsResponse = await postData(tabsUrl, { student_id: std_id });
          const allowed = Array.isArray(tabsResponse?.data)
            ? tabsResponse.data.map((item) => item.tab)
            : [];
            setAllowedTabs(allowed);
    }

    getCourse();
    getTabs();
  }, [courseId]);

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Header />
      <div className="container my-5 px-3 px-md-5">
        {/* Department & Title */}
        <h4 className="text-center mb-3 fw-bold text-uppercase text-info">
          {data[0]?.department}
        </h4>
        <h3 className="text-center mb-5 fw-bold text-uppercase">
          {data[0]?.title}
        </h3>

        {/* Lessons */}
        {data.map((dat, index) => (
          <div key={index} className="mb-5">
            {/* Chapter */}
            <div className="ms-2 ms-md-3 mb-3 fw-semibold">{dat.chapter}</div>
            <hr />

            <div className="row g-4 justify-content-center">
              {/* PPT Section */}
              <div className="col-12 col-md-6">
                <div className="card shadow-lg border-0 rounded-4 h-100">
                  <div className="card-header bg-primary text-white d-flex align-items-center justify-content-between py-3">
                    <div className="fw-semibold">
                      <FeatherIcon icon="file-text" className="me-2" />
                      Lesson Slides (PPT)
                    </div>
                  </div>
                  <div className="card-body text-center bg-light d-flex flex-column justify-content-between">
                    <iframe
                      src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                        `${API_URL}/${dat.pdf}`
                      )}`}
                      width="100%"
                      height="400"
                      frameBorder="0"
                      title={`PPT Viewer ${index}`}
                      className="rounded shadow-sm"
                    ></iframe>
                    <div className="mt-3 text-center">
                      <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center justify-content-center mx-auto"
                        onClick={() => handleDownload(`${API_URL}/${dat.pdf}`)}
                      >
                        <FeatherIcon icon="download" className="me-2" /> Download PPT
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Video Section */}
              <div className="col-12 col-md-6">
                <div className="card shadow-lg border-0 rounded-4 h-100">
                  <div className="card-header bg-success text-white d-flex align-items-center justify-content-between py-3">
                    <div className="fw-semibold">
                      <FeatherIcon icon="video" className="me-2" />
                      Lesson Video
                    </div>
                  </div>
                  <div className="card-body text-center bg-light d-flex flex-column justify-content-between">
                    <video
                      ref={(el) => (videoRefs.current[index] = el)}
                      width="100%"
                      height="400"
                      controls
                      className="rounded shadow-sm"
                      
                      controlsList="nodownload  noplaybackrate "
                       disablePictureInPicture
                          onContextMenu={(e) => e.preventDefault()}
                      onTimeUpdate={() => handleTimeUpdate(index,`${data[0]?.department}_${data[0]?.title}_${dat.chapter}`,dat['chapter_id~hide'])}

                       onLoadedMetadata={() =>
    restoreProgress(
      index,
      `${data[0]?.department}_${data[0]?.title}_${dat.chapter}`,dat['chapter_id~hide']
    )
  }
                    >
                      <source src={`${API_URL}/${dat.video}`} type="video/mp4" />
                        
                      Your browser does not support HTML video.
                    </video>

                  </div>
                   <div style={{ margin: "10px", fontSize: "18px" }}>
                  Watched: <strong>{percent[`${data[0]?.department}_${data[0]?.title}_${dat.chapter}`] || 0}%</strong>
      </div>
                </div>
              </div>
              <div style={{
         display: "flex",
       justifyContent: "center",
      alignItems: "center",
       width:'300px'
   // centers vertically on screen
}}>
 {
  allowedTabs.includes('quiz') && (
    <Link
      to="/quiz"
      state={{
        class_id,
        semester_id,
        course_id,
        student_id,
        chapter_id: dat['chapter_id~hide'],
        exam_type: 3
      }}
      className="btn btn-primary"
      style={{
        fontSize: "20px",
        padding: "12px 35px",
        borderRadius: "10px",
        textDecoration: "none",
        color: "white",
        backgroundColor: "#007bff",
        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={e => (e.target.style.backgroundColor = "#0056b3")}
      onMouseLeave={e => (e.target.style.backgroundColor = "#007bff")}
    >
      Entry Quiz
    </Link>
  )
}

</div>

            </div>
          </div>
        ))}
      </div>

      <MyFooter />
    </>
  );
};

export default CourseDetail;
